/**
 * Moonou Stats Counter — Count-up animation
 * Extracted from moonou-images-with-text.js for standalone use.
 *
 * Finds [data-countup] containers, animates all [data-stat-number] children
 * from 0 to their target value with German thousands-dot formatting.
 */
(function () {
  'use strict';

  var easings = {
    'linear': function (t) { return t; },
    'ease-out': function (t) { return 1 - (1 - t) * (1 - t); },
    'ease-in-out': function (t) {
      return t < 0.5
        ? 2 * t * t
        : 1 - (-2 * t + 2) * (-2 * t + 2) / 2;
    }
  };

  function parseStatNumber(text) {
    text = text.trim();
    var match = text.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!match) return null;

    var prefix = match[1];
    var numStr = match[2];
    var suffix = match[3];

    var useThousandsSep = numStr.indexOf('.') !== -1 && numStr.indexOf(',') === -1;
    var cleaned = numStr.replace(/\./g, '').replace(',', '.');
    var target = parseFloat(cleaned);

    if (isNaN(target)) return null;

    return {
      prefix: prefix,
      target: target,
      suffix: suffix,
      useThousandsSep: useThousandsSep,
      isInteger: target === Math.floor(target)
    };
  }

  function formatNumber(value, useThousandsSep, isInteger) {
    var num = isInteger ? Math.round(value) : Math.round(value * 10) / 10;
    var str = String(num);

    if (useThousandsSep && num >= 1000) {
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      str = parts.join(',');
    }

    return str;
  }

  function animateNumber(el, parsed, duration, easingName) {
    var easing = easings[easingName] || easings['ease-out'];
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / duration, 1);
      var current = easing(progress) * parsed.target;

      el.textContent = parsed.prefix + formatNumber(current, parsed.useThousandsSep, parsed.isInteger) + parsed.suffix;

      if (progress < 1) requestAnimationFrame(step);
    }

    el.textContent = parsed.prefix + formatNumber(0, parsed.useThousandsSep, parsed.isInteger) + parsed.suffix;
    requestAnimationFrame(step);
  }

  function initCountUp(container) {
    var els = container.querySelectorAll('[data-stat-number]');
    var duration = parseInt(container.getAttribute('data-countup-duration'), 10) || 2000;
    var stagger = parseInt(container.getAttribute('data-countup-stagger'), 10) || 200;
    var easingName = container.getAttribute('data-countup-easing') || 'ease-out';

    var items = [];
    els.forEach(function (el) {
      var original = el.getAttribute('data-original') || el.textContent;
      if (!el.getAttribute('data-original')) el.setAttribute('data-original', el.textContent);

      var parsed = parseStatNumber(original);
      if (parsed) {
        items.push({ el: el, parsed: parsed });
        el.textContent = parsed.prefix + formatNumber(0, parsed.useThousandsSep, parsed.isInteger) + parsed.suffix;
      }
    });

    items.forEach(function (item, i) {
      setTimeout(function () {
        animateNumber(item.el, item.parsed, duration, easingName);
      }, i * stagger);
    });
  }

  function initSection(section) {
    var container = section.querySelector('[data-countup]');
    if (!container || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          initCountUp(container);
          observer.unobserve(container);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(container);
    section._msscObs = observer;
  }

  function cleanupSection(section) {
    if (section._msscObs) {
      section._msscObs.disconnect();
      section._msscObs = null;
    }
  }

  function initAll() {
    document.querySelectorAll('.moonou-ssc-section').forEach(function (section) {
      cleanupSection(section);
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.moonou-ssc-section');
    if (section) { cleanupSection(section); initSection(section); }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.moonou-ssc-section');
    if (section) cleanupSection(section);
  });
})();
